import styled, { keyframes } from 'styled-components';

const scaleIn = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
`;

const scaleOut = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 0;
  }
`;

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 215px;
  height: 236px;
  z-index: 2;
  opacity: 0;
  animation: ${props => props.$isExiting ? scaleOut : scaleIn}
    ${props => props.$isExiting ? '0.2s' : '0.5s'}
    ${props => props.$isExiting ? 'ease-out' : 'cubic-bezier(0.65, 0, 0.35, 1)'}
    forwards;
`;

const BadgeWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

export const LoadingBadge = ({ isExiting = false }) => {
  return (
    <Container $isExiting={isExiting}>
      <BadgeWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" width="215" height="236" viewBox="0 0 215 236" fill="none">
          <path opacity="0.9" d="M197.233 46.4929L123.96 4.48944C118.83 1.5475 112.989 0 107.07 0C101.152 0 95.302 1.556 90.1716 4.48944L16.89 46.4929C6.47509 52.4618 0 63.5919 0 75.5382V159.537C0 171.483 6.47509 182.613 16.89 188.582L90.1716 230.585C95.302 233.527 101.143 235.075 107.07 235.075C112.997 235.075 118.838 233.519 123.96 230.585L197.242 188.582C207.665 182.613 214.132 171.483 214.132 159.537V75.5382C214.132 63.5919 207.657 52.4618 197.242 46.4929H197.233Z" fill="url(#paint0_linear_5973_9262)" />
          <defs>
            <linearGradient id="paint0_linear_5973_9262" x1="39" y1="18" x2="169.77" y2="244.5" gradientUnits="userSpaceOnUse">
              <stop stopColor="#A41151" />
              <stop offset="1" stopColor="#C22167" />
            </linearGradient>
          </defs>
        </svg>
      </BadgeWrapper>
    </Container>
  );
}
